<template>
    <FinanceData/>
</template>

<script>
import { FinanceData } from 'shared'

export default {
    name: 'financeData',
    components: {
        FinanceData
    },
    data() {
        return {
            params: {
                name: '数字教育'
            }
        }
    },
    created() {
        this.$store.dispatch('getFinancing', this.params)
    },
}
</script>